import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import renderHTML from 'react-render-html';
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'
let companyInformation;

function Iponews() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [dataLoose, setDataLoose] = useState([]);
    const [dataIndex, setDataIndex] = useState([]);
    const [dataNews, setDataNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataActive, setDataActive] = useState([]);
    const [dataCap, setDataCap] = useState([]);
    const [dataTicker, setDataTicker] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataDraft2, setDataDraft2] = useState([]);
    const [groupValue, setGroupValue] = useState("sno");
    const [dataBest, setDataBest] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [dataIpo, setDataIpo] = useState([]);
    const [dataWatch, setDataWatch] = useState([]);
    const [dataOpen, setDataOpen] = useState([]);
    const [dataClose, setDataClose] = useState([]);
    const [dataBasis, setDataBasis] = useState([]);
    const [dataIssue, setDataIssue] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [dataPer, setDataPer] = useState([]);
    const [fetchIdNews, setFetchIdNews] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [dataaa, setDataaa] = useState([]);
    const [Snonumber, setSnonumber] = useState();
    const [loadingshow, setloadingshow] = useState(false);
    // const [groupValue, setValueBtn] = useState("sebi");
    const [type, settype] = useState(['sebi']);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let companyInformation;
    let getData, getDataLoose, getDataIndex, getDataTicker, fetchId,
        getDataActive, getDataNews, getDataCap, getDataBest, getDataDraft, getDataDraft2, getDataNew, getDataIpo, getDataWatch, getDataOpen, getDataClose, getDataBasis, getDataIssue, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        const getUrlIpo = BaseURL + "News";
        fetch(`${getUrlIpo}/28/117/-/8`)
            .then((response) => response.json())
            .then((dataI) => {
                getDataIpo = dataI.data;
                setDataIpo(getDataIpo);
                //console.log(getDataIpo, "getDataIpo")
                companyInformation = dataI.data;
                //console.log(dataI.data)
                setCompanyInfo(companyInformation);
                //console.log("data", companyInformation);
                setloadingshow(false);
            })
            .catch((error) => {
            });
    }, []);

    // const handleClosePopup = () => {
    //     setShow(false);
    // }

    // const knowMoreBtn = () => {
    //     handleShow();
    // };

    // const newsModal = (e) => {
    //     const fetchId = e.currentTarget.getAttribute('data-id');
    //     let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['Sno']) === parseInt(fetchId) })
    //     //console.log(filteredCompanyInformation)
    //     setFilteredNewsData(filteredCompanyInformation)
    //     handleShow();
    // }

    const routeChange = (event) => {
        const fetchId = event.currentTarget.getAttribute('data-id');
        const fetchHead = event.currentTarget.getAttribute('data-head');
        window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace(/\./g,'').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(':', 'colon').replace('%', 'Percent'), '_blank');
    };


    const moreContent = () => {
        navigate("/IPO/IPO-News")
    }

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>IPO News</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                {(dataIpo === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                <Container className="add-border table-box">
                    {(dataIpo != null) && dataIpo.map(
                        ({ Heading, Date, Time, Sno }) => (
                            <>
                                <div className="IPOnews-wq">
                                    <div className="IPOnews-wq-inner">
                                        <div className="IPOnews-wq-betaNews">
                                            <div className="IPOnews-gutter">
                                                {/* <a data-id={Sno} onClick={newsModal}>
                                                    <a onClick={knowMoreBtn}> */}
                                                        <h6 className="newheadIpo more-info" onClick={routeChange} data-head={Heading} data-id={Sno}>{Heading} </h6>
                                                        <p> {(Date.split('T')[0])}  ({Time})</p>
                                                    {/* </a>
                                                </a> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    {loadingshow ? <div className="textcentervertex">
                        <Vortex
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="vortex-loading"
                            wrapperStyle={{}}
                            wrapperClass="vortex-wrapper"
                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                        />
                        <div className="model_popup">Please Wait...</div>
                    </div> : ""
                    }

                    {/* {filteredNewsData &&
                        filteredNewsData.map(({ co_code, Sno, Heading, Date, Time, Arttext, memo }) => (
                            <Modal show={show} className="modal company-snap-modal">
                                <Modal.Body id="modal_info">
                                    <div className="titleCompany">{Heading}</div>
                                    <div className="btnDiv">
                                        <div className="btncl" onClick={handleClosePopup}> X </div>
                                    </div>
                                    <div className="infoCompany">{renderHTML(Arttext)}</div>
                                </Modal.Body>
                            </Modal>
                        ))} */}

                </Container>



            </div>
        </>
    );
}

export default Iponews;


